import authHeader from "../../../authentication/authservices/auth-header";
import apiClient from "../../../http-common";

export const saveComplaintServices = (ListingObj) => {
  return apiClient.post("/complaintsServiceMaster/save", ListingObj);
};
//complaintServices/update
export const UpdateComplaintServices = (ListingObj) => {
  return apiClient.put("/complaintsServiceMaster/update", ListingObj);
};

export const getComplaintServicesList = (ListingObj) => {
  return apiClient.post("/complaintsServiceMaster/list", ListingObj);
};

export const getComplaintServicesDropDown = () => {
  return apiClient.get(`/complaintServices/getMealDropDown`, {
    headers: authHeader(),
  });
};

export const getComplaintCategoryDeleteById = (id) => {
  return apiClient.delete(`/complaintsServiceMaster/delete/${id}`);
};

export const getSearchComplaintServices = (searchString) => {
  return apiClient.get(`/complaintsServiceMaster/autoComplete/${searchString}`);
};

export const getComplaintServicesFindById = async (id) => {
  return apiClient.get(
    `/complaintsServiceMaster/getComplaintServiceMasterById/${id}`
  );
};

export const getComplaintCategoryDropDown = async (id) => {
  // return await apiClient.get(`/complaintServices/${id}`, {
  //   headers:authHeader(),
  // });
};
